













































// @ts-nocheck
import { Component, Prop, Vue } from 'vue-property-decorator'
import { AppModule } from '@/app/store/modules/app'
import { AuthModule } from '@/app/store/modules/auth'
import SidebarLogo from './sidebarlogo.vue'
import SidebarItem from './SidebarItem.vue'
import SidebarFooter from './SidebarFooter.vue'
import { getUserRolePermission } from '@/utils/cookies'
import variables from '@/app/ui/styles/_variables.scss'
import Layout from '@/app/ui/layout/index.vue'
import { routeList } from '@/router'

@Component({
  name: 'SideBar',
  components: {
    SidebarLogo,
    SidebarItem,
    SidebarFooter,
  },
})
export default class extends Vue {
  get sidebar() {
    return AppModule.sidebar
  }

  public get needSalesCode() {
    const powerUser = AuthModule.salesCode.role
    if (powerUser !== 'Super Admin') {
      return true
    }
    return false
  }
  public get hideRoutes() {
    const listRoute = routeList.filter((item) => {
      const meta = item.meta && item.meta.title
      // Vue.delete(routeList[5].children[5], 'meta')
      return AuthModule.menu.map((data) => data.name).includes(meta)
    })

    listRoute.push({
      path: '/404',
      component: Layout,
      children: [
        {
          path: 'index',
          name: '404',
          component: () =>
            import(
              /* webpackChunkName: "profile-menu" */ '@/app/ui/views/404/index.vue'
            ),
        },
      ],
    })
    return listRoute
  }

  get routes() {
    const listRoute = routeList.filter((item) => {
      const meta = item.meta && item.meta.title
      return AuthModule.menu.map((data) => data.name).includes(meta)
    })

    listRoute.push({
      path: '/404',
      component: Layout,
      children: [
        {
          path: 'index',
          name: '404',
          component: () =>
            import(
              /* webpackChunkName: "profile-menu" */ '@/app/ui/views/404/index.vue'
            ),
        },
      ],
    })

    // this.$hideRoutes()
    return listRoute
    this.hideRoutes()
  }

  get variables() {
    return variables
  }

  get isCollapse() {
    return !this.sidebar.opened
  }
}
